import React, { FC } from 'react';
import { MetricHeader } from '@/components/pages/blockSchedule/metrics/MetricHeader';
import { styled, Typography, CircularProgress } from '@material-ui/core';
import Box from '@material-ui/core/Box';

type MetricProps = {
  title: string;
  tooltip?: string;
  value?: string | null;
  subvalue?: string | null;
  valueNode?: React.ReactNode;
  subvalueNode?: React.ReactNode;
  loading?: boolean;
};

export const Metric: FC<MetricProps> = ({
  title,
  tooltip,
  value,
  subvalue,
  valueNode,
  subvalueNode,
  loading = false,
}) => (
  <MetricBox>
    <MetricHeader title={title} tooltip={tooltip} />
    {loading && (
      <LoadingContainer>
        <CircularProgress size={20} />
      </LoadingContainer>
    )}
    {!loading && (valueNode || value) && (
      <>
        <MetricValue>{valueNode || value}</MetricValue>
        {(subvalueNode || subvalue) && <MetricSubvalue>{subvalueNode || subvalue}</MetricSubvalue>}
      </>
    )}
  </MetricBox>
);

const MetricBox = styled(Box)(({ theme }) => ({
  background: 'transparent',
  minHeight: 'unset',
  padding: theme.spacing(0, 1),
}));

const MetricValue = styled(Typography)(({ theme }) => ({
  fontSize: '1.75rem',
  fontWeight: theme.typography.fontWeightBold as number,
  color: theme.palette.text.primary,
  textAlign: 'center',
  lineHeight: 1,
  marginBottom: theme.spacing(0.5),
  [theme.breakpoints.down('md')]: {
    fontSize: '1.375rem',
    marginBottom: theme.spacing(0.5),
  },
}));

const MetricSubvalue = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: theme.typography.fontWeightMedium as number,
  color: theme.palette.text.secondary,
  textAlign: 'center',
  lineHeight: 1,
  opacity: 0.9,
  [theme.breakpoints.down('md')]: {
    fontSize: '0.9rem',
  },
}));

const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(2, 0),
}));
